import styled from 'styled-components'

import {
    font,
    media,
    radius,
    theme,
    Button,
    Container,
    Flexer,
    Heading,
    InlineLink,
    ModalLegacy as Modal,
    Paragraph,
} from '@scouts/ui'

import announcementImage from '@/assets/images/taxfix-announcement.png'

interface TaxfixAnnouncementModalProps {
    onClose: VoidFunction
}

export const TaxfixAnnouncementModal = ({ onClose }: TaxfixAnnouncementModalProps) => (
    <Modal onClose={onClose} isWide>
        <Container
            background={theme.primary.background}
            padding="24px 24px 48px"
            tabletPadding="48px 60px"
            desktopPadding="60px 72px"
            radius={radius.large}
        >
            <Flexer spaceBetween alignCenter gap="30px" flexWrap>
                <Body>
                    <Heading
                        family={font.family.display}
                        size={font.display.large}
                        tabletSize={font.display.xlarge}
                        color={theme.primary.contrast}
                    >
                        Tu gestoría online, ahora con nuevo look
                    </Heading>
                    <Paragraph>TaxScouts es ahora Taxfix.</Paragraph>
                    <Flexer column tabletRow alignCenter gap="30px">
                        <Button size="large" isMobileFullWidth onClick={onClose}>
                            ¡Entendido!
                        </Button>
                        <InlineLink
                            href="https://taxfix.com/es-es/blog/taxscouts-es-ahora-taxfix"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Saber más
                        </InlineLink>
                    </Flexer>
                </Body>

                <Image src={announcementImage} alt="Taxfix anuncio" />
            </Flexer>
        </Container>
    </Modal>
)

const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    order: 2;

    ${media.tablet} {
        order: 1;
        width: 50%;
    }
`

const Image = styled.img`
    max-width: 50%;
    height: auto;
    margin: 0 auto;
    order: 1;

    ${media.tablet} {
        order: 2;
        width: 40%;
    }
`
